import React from "react";
import { Container, Grid, Divider } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";

function FeedbackSkeleton({ assigned = false }) {
  if (assigned) {
    return (
      <Container component="main" maxWidth="md" sx={{ paddingTop: 2, paddingBottom: 2 }}>
        <Divider style={{ marginTop: 16, marginBottom: 16 }} />

        {/* Title "Avalie seu chamado" */}
        <Skeleton variant="text" width={280} height={38} />

        {/* Called ID row */}
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}>
          <Skeleton variant="circular" width={22} height={22} />
          <Skeleton variant="text" width={140} height={22} />
        </div>

        <Divider style={{ marginTop: 16, marginBottom: 16 }} />

        {/* Responsible row */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Skeleton variant="circular" width={22} height={22} />
          <Skeleton variant="text" width={220} height={22} />
        </div>

        <Divider style={{ marginTop: 16, marginBottom: 16 }} />

        {/* Responsible row */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Skeleton variant="circular" width={22} height={22} />
          <Skeleton variant="text" width={220} height={22} />
        </div>

        <Divider style={{ marginTop: 16, marginBottom: 16 }} />

        {/* "Ultimo Acompanhamento" row */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Skeleton variant="circular" width={22} height={22} />
          <Skeleton variant="text" width={280} height={22} />
        </div>

        <Divider style={{ marginTop: 16, marginBottom: 16 }} />

        {/* Title "O que você achou do Atendimento" */}
        <Skeleton variant="text" width={280} height={38} />
        <Skeleton variant="text" width={180} height={28} sx={{ marginBottom: 2 }} />

        {/* Star rating row */}
        <Skeleton variant="text" width={120} height={22} sx={{ marginBottom: 4 }} />

        {/* Comment textarea */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={180}
          sx={{ borderRadius: 1, marginBottom: 3 }}
        />

        {/* Submit button */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Skeleton
            variant="rectangular"
            width={180}
            height={42}
            sx={{ borderRadius: 1 }}
          />
        </div>
      </Container>
    )
  }

  return (
    <Container component="main" maxWidth="md" sx={{ paddingTop: 2, paddingBottom: 2 }}>
      {/* Header logo */}
      <Grid item xs={12} style={{ paddingLeft: 0, marginTop: "10px", marginBottom: "10px" }}>
        <Skeleton variant="rectangular" width={200} height={200} sx={{ borderRadius: 2 }} />
      </Grid>

      {/* Banner bar */}
      <Skeleton
        variant="rectangular"
        width="60%"
        height={65}
        sx={{ borderRadius: "0 28px 28px 0", marginBottom: 3 }}
      />

      <Divider style={{ marginTop: 16, marginBottom: 16 }} />

      {/* Title "Avalie seu chamado" */}
      <Skeleton variant="text" width={180} height={28} sx={{ marginBottom: 1 }} />

      {/* Called ID row */}
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 12 }}>
        <Skeleton variant="circular" width={22} height={22} />
        <Skeleton variant="text" width={140} height={22} />
      </div>

      <Divider style={{ marginTop: 16, marginBottom: 16 }} />

      {/* Responsible row */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Skeleton variant="circular" width={22} height={22} />
        <Skeleton variant="text" width={220} height={22} />
      </div>

      <Divider style={{ marginTop: 16, marginBottom: 16 }} />

      {/* Description row */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Skeleton variant="circular" width={22} height={22} />
        <Skeleton variant="text" width={280} height={22} />
      </div>

      <Divider style={{ marginTop: 16, marginBottom: 16 }} />

      {/* Accordion "Ultimo Acompanhamento" */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={48}
        sx={{ borderRadius: 1, marginBottom: 2 }}
      />

      <Divider style={{ marginTop: 16, marginBottom: 16 }} />

      {/* Question label */}
      <Skeleton variant="text" width="70%" height={24} sx={{ marginBottom: 2, marginTop: 1 }} />

      {/* SIM / NÃO buttons */}
      <Grid container spacing={0} justifyContent={"center"} style={{ marginBottom: 24 }}>
        <Grid item>
          <Skeleton
            variant="rectangular"
            width={120}
            height={52}
            sx={{ borderRadius: "4px 0 0 4px" }}
          />
        </Grid>
        <Grid item>
          <Skeleton
            variant="rectangular"
            width={120}
            height={52}
            sx={{ borderRadius: "0 4px 4px 0", marginLeft: "2px" }}
          />
        </Grid>
      </Grid>

      {/* Comment textarea */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={180}
        sx={{ borderRadius: 1, marginBottom: 3 }}
      />

      {/* Submit button */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Skeleton
          variant="rectangular"
          width={180}
          height={42}
          sx={{ borderRadius: 1 }}
        />
      </div>
    </Container>
  );
}

export default FeedbackSkeleton;
